import React from 'react';
import withDrawingContainer, { withDrawingContainerProps } from './withDrawingContainer';
import { Line } from 'react-konva';
import { DrawingType, ScribbleUpdateDetails } from '../constants';
import { getRgbColorString } from '../utils';

interface Props extends withDrawingContainerProps {
  points: number[];
  color: string;
}
const ScribbleDrawing = (props: Props) => {
  const { id, points, color, isSelected } = props;
  return (
    <>
      <Line
        id={`scribbledrawing-line-${id}`}
        points={points}
        stroke={getRgbColorString(color)}
        shadowBlur={isSelected ? 10 : 0}
        shadowColor={isSelected ? 'black' : ''}
        shadowOpacity={isSelected ? 5 : 0}
        shadowEnabled={isSelected ? true : false}
        strokeWidth={3}
        tension={0.5}
        lineCap="round"
      />
    </>
  );
};

const moveActionPreProcessor = (
  props: Props,
  x: number,
  y: number,
): ScribbleUpdateDetails => {
  const [transformedX, transformedY] = props.tpObject.FromCanvasToDb(x, y);
  return { x, y, dbX: transformedX, dbY: transformedY };
};

export default withDrawingContainer(
  ScribbleDrawing,
  DrawingType.Scribble,
  moveActionPreProcessor,
);
